import styles from './Header.module.css';
import HeroDesktop from './Hero.jpg';
import HeroMob from './Hero-mob.jpg';
import logo from './Logo.png';

export default function Header() {

  return (<header className={styles.header}>
    <div className={styles.logo}>
    <img src={logo} alt="Logo Club de Madrid" /></div>
    <img src={HeroDesktop} className={styles.desktopImage} alt="Header image" />
    <img src={HeroMob} className={styles.mobImage} alt="Header image" />

  </header>);
}
